const suppliers = {
  toast: {
    error: {
      badResponse: '[Anbieter] fehlerhafte Serverantwort',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[Anbieter] wurde erfolgreich erstellt',
      },
      edit: {},
    },
  },
  createNew: 'Erstellen',
  updateRanking: 'Rangliste aktualisieren',
  table: {
    headers: {
      name: 'Name',
      rank: 'Rang',
      tier: 'Tier',
      overallScore: 'Gesamtpunktzahl',
      onTimePerformance: 'Pünktlich %',
      noShowRate: 'Nichterscheinen %',
      cancellationsRate: 'Stornierungsrate %',
      acceptanceRate: 'Akzeptanzrate %',
      avgResponseTime: 'Durchschnittliche Reaktionszeit',
      complaints: 'Beschwerden',
      vehicles: 'Fahrzeuge',
      supplierStatus: 'Status',
    },
    actions: {
      delete: 'Löschen',
      export: 'Exportieren',
    },
    toolTip: {
      noPermission: 'Aktion nicht zulässig: Berechtigung erforderlich',
    },
  },
  create: {
    successToast: {
      message: 'Erfolg! Anbieter erstellt!',
    },
    errorToast: {
      message: 'Es ist ein Fehler aufgetreten. Anbieter konnte nicht erstellt werden.',
    },
  },
  edit: {
    successToast: {
      message: 'Erfolg! Anbieter aktualisiert!',
    },
    errorToast: {
      message: 'Es ist ein Fehler aufgetreten. Anbieter konnte nicht aktualisiert werden.',
    },
  },
  deleteModal: {
    header: 'Anbietern löschen',
    body: 'Sie sind dabei, {{num}} Anbietern zu löschen.',
  },
  deleteToast: 'Anbietern können nicht gelöscht werden',
  forms: {
    header: {
      createSupplier: {
        title: 'Erstellen',
      },

      updateSupplier: {
        title: 'Aktualisieren',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
      },
    },

    information: {
      rank: {
        header: 'Anbieterenrang und -punktzahl',
        fields: {
          rank: 'Rang {{rank}}',
          score: 'Score: ',
        },
      },
      generalInformation: {
        header: 'Allgemeine Informationen',
        fields: {
          name: 'Name',
          status: 'Status',
          tier: 'Tier',
          tierAndScore: 'Supplier Tier and Score',
          statusOptions: {
            select: 'Wählen',
            active: 'Aktiv',
            inactive: 'Inaktiv',
          },
        },
      },
      supplierKpis: {
        header: 'Anbieteren-KPIs',
        fields: {
          onTimePerformance: 'Pünktliche Leistung (%)',
          noShowRate: 'Nichterscheinen-Rate (%)',
          cancellationsRate: 'Stornierungsrate (%)',
          acceptanceRate: 'Akzeptanzrate (%)',
          avgResponseTime: 'Durchschnittliche Reaktionszeit (min)',
          complaints: 'Beschwerden',
        },
      },
      advancedSettings: {
        header: 'Erweiterte Einstellungen',
        fields: {
          areas: 'Zonen',
          attributes: 'Eigenschaften',
          excludedAttributes: 'Ausgeschlossene Eigenschaften',
          minTrips: 'Min. Fahrten',
          maxTrips: 'Max. Fahrten',
          allowDecline: 'Ablehnen zulassen',
          allowSharedRides: 'Gemeinsame Fahrten zulassen',
          weekDays: 'Verfügbarkeit an Wochentagen',
        },
      },
      contactInformation: {
        header: 'Kontaktinformationen',
        fields: {
          name: 'Name',
          type: 'Typ',
          phone: 'Telefon',
          email: 'E-Mail',
          address: 'Adresse',
          comment: 'Kommentar',
          btnAddContact: 'Kontakt hinzufügen +',
        },
      },
      notes: {
        header: 'Hinweise',
        fields: {
          notes: 'Hinweise',
        },
      },
      vehiclesTable: {
        cells: {
          name: 'Name',
          seats: 'Sitzplätze',
          attributes: 'Eigenschaften',
        },
      },
    },
    select: 'Wählen',
  },
  delete: {
    confirmation: {
      header: 'Anbieterenbestätigung löschen',
      body: 'Anbieteren wurden erfolgreich gelöscht',
    },
  },
};

export default suppliers;
